module.exports = __webpack_public_path__ + "img/selecao-area.efc750c8.svg";